import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable max-len */
import { BRA_MEASUREMENTS, BRA_SIZES, EU_SHOES, GENDERS, KIDS_SIZES, MEN_SIZES, MEN_SIZES_EXTENDED, RAPHA_SIZES, SIZES, SIZES_EXTENDED, SIZES_KIDS, TEXT, WOMEN_SIZES, WOMEN_SIZES_EXTENDED, UNISEX_SIZES, UNISEX_SIZES_EXTENDED } from '../../config/constants-sizes';
import { CONTACT_EMAIL } from '../../config/constants';
var shoesTitle = TEXT.shoes.title;
var womensShoes = WOMEN_SIZES[WOMEN_SIZES.length - 1];
var mensShoes = MEN_SIZES[MEN_SIZES.length - 1];

var getGenderRows = function getGenderRows(sizeGuides) {
  var newGuide = [];
  sizeGuides.filter(function (_ref) {
    var category = _ref.category,
        sizes = _ref.sizes,
        inches = _ref.inches;

    if (category === shoesTitle) {
      return false;
    }

    var newSizes = sizes;

    if (inches) {
      newSizes = sizes.map(function (sz) {
        return "".concat(sz, "\"");
      });
    }

    newGuide.push([category].concat(_toConsumableArray(newSizes)));
    return true;
  });
  return newGuide;
};

var DATA_BRA = {
  blankColLabel: TEXT.bra.colLabel,
  head: [''].concat(_toConsumableArray(BRA_MEASUREMENTS.sizes)),
  headMobile: [],
  rows: BRA_SIZES.map(function (_ref2) {
    var category = _ref2.category,
        sizes = _ref2.sizes;
    return [category].concat(_toConsumableArray(sizes));
  }),
  rowsMobile: BRA_SIZES.map(function (_ref3) {
    var category = _ref3.category,
        sizes = _ref3.sizes;
    return [category].concat(_toConsumableArray(sizes));
  }),
  subtitle: TEXT.bra.guide,
  title: TEXT.bra.title
};
var DATA_WOMEN = {
  blankColLabel: TEXT.fit.colLabel,
  flipMobile: true,
  head: [''].concat(_toConsumableArray(SIZES)),
  rows: getGenderRows(WOMEN_SIZES),
  subtitle: TEXT.fit.guide,
  title: TEXT.fit.title,
  gender: GENDERS.WOMEN
};

var DATA_WOMEN_ES = _objectSpread(_objectSpread({}, DATA_WOMEN), {}, {
  head: [''].concat(_toConsumableArray(SIZES_EXTENDED)),
  rows: getGenderRows(WOMEN_SIZES_EXTENDED)
});

var DATA_MEN = {
  blankColLabel: TEXT.fit.colLabel,
  gender: GENDERS.MEN,
  head: [''].concat(_toConsumableArray(SIZES)),
  flipMobile: true,
  rows: getGenderRows(MEN_SIZES),
  subtitle: TEXT.fit.guide,
  title: TEXT.fit.title
};

var DATA_MEN_ES = _objectSpread(_objectSpread({}, DATA_MEN), {}, {
  head: [''].concat(_toConsumableArray(SIZES_EXTENDED)),
  rows: getGenderRows(MEN_SIZES_EXTENDED)
});

var DATA_UNISEX = {
  blankColLabel: TEXT.fit.colLabel,
  gender: GENDERS.UNISEX,
  head: [''].concat(_toConsumableArray(SIZES)),
  flipMobile: true,
  rows: getGenderRows(UNISEX_SIZES),
  subtitle: TEXT.fit.guide,
  title: TEXT.fit.title
};

var DATA_UNISEX_ES = _objectSpread(_objectSpread({}, DATA_UNISEX), {}, {
  head: [''].concat(_toConsumableArray(SIZES_EXTENDED)),
  rows: getGenderRows(UNISEX_SIZES_EXTENDED)
});

var DATA_KIDS = {
  blankColLabel: TEXT.fit.colLabel,
  flipMobile: true,
  subtitle: TEXT.fit.guide,
  title: TEXT.fit.title,
  head: [''].concat(_toConsumableArray(SIZES_KIDS)),
  rows: getGenderRows(KIDS_SIZES)
};
var SIZE_GUIDES = {
  BRA: {
    guides: [_objectSpread({}, DATA_BRA), _objectSpread({}, DATA_WOMEN)]
  },
  BRA_FULL: {
    footer: {
      title: 'Fit Notes',
      copy: "<ul>\n    <li>We recommend taking your normal cup size for bras</li>\n    <li>For an estimate on sizing on your band, use a measuring tape to measure around your torso directly under your bust.</li>\n    <li>Still unsure? Email our team at <a href=\"mailto:".concat(CONTACT_EMAIL, "?subject=[Size Guide] Help with sizing\">").concat(CONTACT_EMAIL, "</a> for further help with sizing</li>\n    </ul>")
    },
    guides: [{
      flipMobile: false,
      head: ['OV Size', 'Actual Band Measurement'],
      rows: [['S/M - B Cup', "24 1/2 – 26''"], ['S/M - C Cup', "25 1/2 – 27''"], ['S/M - D Cup', "26 1/2 – 28''"], ['S/M - DD Cup', "27 1/2 – 29''"], ['L/XL - C Cup', "27 1/2 – 29''"], ['L/XL - D Cup', "28 1/2 – 30''"], ['L/XL - DD Cup', "29 1/2 – 31''"]],
      subtitle: TEXT.fit.guide,
      title: TEXT.fit.title
    }]
  },
  EU_SHOES: {
    guides: [{
      title: shoesTitle,
      subtitle: TEXT.shoes.guide,
      flipMobile: true,
      head: ['European'].concat(_toConsumableArray(EU_SHOES.sizes)),
      rows: [['Women – US'].concat(_toConsumableArray(womensShoes.sizes)), ['Men – US'].concat(_toConsumableArray(mensShoes.sizes))]
    }]
  },
  KIDS: {
    guides: [_objectSpread({}, DATA_KIDS)]
  },
  LEGGING: {
    guides: [_objectSpread({}, DATA_WOMEN), _objectSpread({}, DATA_BRA)]
  },
  MEN: {
    guides: [_objectSpread({}, DATA_MEN)]
  },
  MEN_ES: {
    guides: [_objectSpread({}, DATA_MEN_ES)]
  },
  RAPHA: {
    barTitle: 'Rapha + Outdoor Voices Size Chart',
    guides: [{
      gender: GENDERS.UNISEX,
      head: [''].concat(_toConsumableArray(SIZES)),
      flipMobile: true,
      rows: getGenderRows(RAPHA_SIZES),
      subtitle: TEXT.fit.guide,
      title: TEXT.fit.title
    }]
  },
  WOMEN: {
    guides: [_objectSpread({}, DATA_WOMEN), _objectSpread({}, DATA_BRA)]
  },
  WOMEN_ES: {
    guides: [_objectSpread({}, DATA_WOMEN_ES), _objectSpread({}, DATA_BRA)]
  },
  UNISEX: {
    guides: [_objectSpread({}, DATA_UNISEX)]
  },
  UNISEX_ES: {
    guides: [_objectSpread({}, DATA_UNISEX_ES)]
  }
};
export default SIZE_GUIDES;